export default "__VITE_ASSET__FgtJ8lTM__"